import React, { useState } from "react";
import Popover from "react-popover";
import info_icon from "../../assets/dashboard/info_icon.svg";
import { BOOKING_TYPE } from "./Constants";

function OnlinePayment({
  consultationFees,
  totalDiscount,
  gst,
  convenienceFee,
  partialPaymentFee,
  pendingAmount,
  totalFees,
  phoneNumber,
  handlePhoneOnChange,
  sendSMS,
  showTimer,
  phno,
  count,
  counter,
  sendBtnDisabled,
  appointmentType,
  handleCashPaymentClick,
  procedureFeeList,
  totalCustomGst,
  hasResourceAccess,
  addBooking,
  selectedBookingType,
  handleResoureSubmit,
}) {
  const [isOpen, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isOpenConsultationGst, setOpenConsultationGst] = useState(false);
  // Helper Methods ===>

  const getSendBtnDisabled = () => {
    return showTimer || phno?.length !== 10 || sendBtnDisabled;
  };

  // <===

  // Actions ===>

  const handlePopoverOpen = (event, type) => {
    if (type === "consultation_fee_gst") {
      setOpenConsultationGst(true);
    } else {
      setOpen(true);
    }
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = (type) => {
    if (type === "consultation_fee_gst") {
      setOpenConsultationGst(false);
    } else {
      setOpen(false);
    }
    setAnchorEl(null);
  };

  // <===

  // Display UI ===>

  function resourceProcedueList() {
    let hasGst = procedureFeeList.some(
      (procedure) => +procedure?.custom_gst_in_rupees > 0
    );

    return (
      <div className="resource-ammount-table-container">
        <div className="resource-table-header">
          <div className="resorce-discription">Description of Service</div>
          <div className="resource-fee">Fee</div>
          {hasGst && <div className="resource-fee">GST</div>}
          <div className="resource-amount">Amount</div>
        </div>
        <div className="resource-body-content">
          {procedureFeeList?.map((data) => (
            <div className="resource-body-content-wrapper">
              <div className="resorce-discription">
                <div>{data.procedure_name}</div>
              </div>
              <div className="resource-fee">
                <div>₹{data.consultation_fees}</div>
              </div>
              {hasGst && (
                <div className="resource-gst">
                  <div>₹{data.custom_gst_in_rupees}</div>
                </div>
              )}
              <div className="resource-amount">
                <div>₹{data.amount_with_gst}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  const displayConsultationFeeSection = () => {
    let infoText = "GST is applied on discounted Consultation fee";
    return (
      <div className="online-payment-section-container">
        <div className="online-payment-section">
          <div>Consultation Fee</div>
          <div>
            {"₹ "} {consultationFees}
          </div>
        </div>
        {+totalDiscount > 0 && (
          <div className="online-payment-discount-section">
            <div>Total Discount</div>
            <div>
              {"₹ "} {totalDiscount}
            </div>
          </div>
        )}
        {+totalCustomGst > 0 && (
          <div className="online-payment-section" style={{ marginTop: "15px" }}>
            <div className="online-payment-gst-text">
              GST{" "}
              {displayInfo(
                isOpenConsultationGst,
                "consultation_fee_gst",
                infoText
              )}
            </div>
            <div>
              {"₹ "} {totalCustomGst}
            </div>
          </div>
        )}
      </div>
    );
  };

  const displayGSTSection = () => {
    let infoText = "GST is Applied on the Convenience Fee";
    return (
      <div className="online-payment-section-container">
        {(hasResourceAccess ||
          (addBooking && selectedBookingType === BOOKING_TYPE.LABORATORY)) &&
          +totalDiscount > 0 && (
            <div
              className="online-payment-discount-section"
              style={{ marginBottom: "20px" }}
            >
              <div>Total Discount</div>
              <div>
                {"₹ "} {totalDiscount}
              </div>
            </div>
          )}
        {+partialPaymentFee > 0 && (
          <div
            className="online-payment-section"
            style={{ marginBottom: "15px" }}
          >
            <div>Partial Payment</div>
            <div>
              {"₹ "} {partialPaymentFee}
            </div>
          </div>
        )}

        <div className="online-payment-section" style={{ marginTop: "10px" }}>
          <div>Convenience Fees</div>
          <div>
            {"₹ "} {convenienceFee}
          </div>
        </div>
        <div className="online-payment-section" style={{ marginTop: "15px" }}>
          <div className="online-payment-gst-text">
            GST {displayInfo(isOpen, "convenience_fee_gst", infoText)}
          </div>
          <div>
            {"₹ "} {gst}
          </div>
        </div>
      </div>
    );
  };

  const displayTotalFee = () => {
    return (
      <div className="online-payment-section-container">
        <div className="online-payment-total-fee-section">
          <div>TOTAL FEE</div>
          <div>
            {"₹ "} {totalFees}
          </div>
        </div>
      </div>
    );
  };

  const displayInfo = (isOpen, type, info) => {
    return (
      <Popover
        isOpen={isOpen}
        preferPlace={`below`}
        place={null}
        anchorEl={anchorEl}
        body={displayHoverContent(info)}
      >
        <img
          src={info_icon}
          alt=""
          style={{ cursor: "pointer", marginLeft: "5px" }}
          onMouseOver={(e) => handlePopoverOpen(e, type)}
          onMouseOut={() => handlePopoverClose(type)}
        />
      </Popover>
    );
  };

  const displayHoverContent = (infoText) => {
    return (
      <div
        style={{
          padding: "6px 10px",
          fontSize: "12px",
          width: "100%",
          textAlign: "center",
        }}
      >
        {infoText}
      </div>
    );
  };

  const displayPendingAmountSection = () => {
    return (
      <div className="online-payment-section-container">
        <div className="online-payment-section">
          <div>Pending Amount</div>
          <div>
            {"₹ "} {pendingAmount}
          </div>
        </div>
      </div>
    );
  };

  // <===

  return (
    <div
      className="online-payment-container"
      style={{ marginTop: appointmentType !== "in-clinic" ? "15px" : "" }}
    >
      {(hasResourceAccess ||
        (addBooking && selectedBookingType === BOOKING_TYPE.LABORATORY)) &&
        resourceProcedueList()}
      {((!hasResourceAccess && !addBooking) ||
        (addBooking && selectedBookingType === BOOKING_TYPE.CLINIC)) &&
        displayConsultationFeeSection()}
      {displayGSTSection()}
      {+pendingAmount > 0 && displayPendingAmountSection()}
      {displayTotalFee()}

      <div className="row">
        <div className="col-lg-10 col-12 mt-2">
          <h3>Share Payment Link Via</h3>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-10 col-12 mt-2 d-flex flex-row icon-wrapper">
          <button class="btn btn-lg d-flex flex-column justify-content-center icon-card  active-payment-mode">
            <i class="icon-sms mb-1"></i>
            <span className="icon-label">C2C SMS</span>
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-8 col-12 my-4">
          <div class="input-group phno_style">
            <div class="input-group-prepend">
              <span class="input-group-text prefix">+91</span>
            </div>
            <input
              type="number"
              class="form-control inpt"
              placeholder="Enter Phone Number"
              value={phoneNumber}
              onChange={handlePhoneOnChange}
            />
            <div class="input-group-append">
              <button
                class="button-display"
                type="button"
                onClick={
                  hasResourceAccess ||
                  (addBooking &&
                    selectedBookingType === BOOKING_TYPE.LABORATORY)
                    ? handleResoureSubmit
                    : sendSMS
                }
                disabled={getSendBtnDisabled()}
              >
                {count > 0 ? "Resend" : "Send"}
              </button>
            </div>
          </div>
          {showTimer ? (
            <p className="mt-1">{"0:" + counter + " left to Re-send"}</p>
          ) : (
            ""
          )}
        </div>
      </div>
      {showTimer && appointmentType === "in-clinic" ? (
        <div className="row">
          <div className="col-lg-8 col-12 mt-1">
            <div class="card bg-light cursor-pointer card_bg">
              <div class="card-body text-center p-0 py-2 d-flex flex-column">
                <p class="m-0">
                  <small>
                    Payment link is successfully shared with patient.
                  </small>
                </p>
                <p class="m-0">
                  <small>
                    If not received by patient, please select
                    <a
                      onClick={handleCashPaymentClick}
                      className="stretched-link"
                    >
                      &nbsp;By Cash
                    </a>
                    .
                  </small>
                </p>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}

export default OnlinePayment;
